import { jsPDF } from "jspdf";

const BASE = "BROTHERS ADVERTISING™";
const CONTACT = "Customer Care 022 4742 7059  ·  +91 80709 70980  ·  print@brothersdigital.in";
const ADDR = "Shop No. 02, Payal Residency, Plot No. 29, Sector 16, Taloja Phase 2, Navi Mumbai - 410208";

function drawHeader(doc, subtitle) {
  const pageW = doc.internal.pageSize.getWidth();
  doc.setFillColor(0, 0, 0);
  doc.rect(0, 0, pageW, 70, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text(BASE, 40, 34);
  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.text(CONTACT, 40, 50);
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(subtitle, 40, 100);
}

function drawFooter(doc) {
  const h = doc.internal.pageSize.getHeight();
  doc.setFontSize(7);
  doc.setTextColor(120);
  doc.text(ADDR, 40, h - 22);
  doc.text(`Generated ${new Date().toLocaleString()}`, 40, h - 12);
}

function drawTable(doc, headers, rows, startY, columnWidths) {
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  let y = startY;
  const rowHeight = 16;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setFillColor(240, 240, 240);
  doc.rect(40, y - 12, pageW - 80, rowHeight, "F");
  let x = 40;
  headers.forEach((h, i) => {
    doc.text(String(h), x + 4, y);
    x += columnWidths[i];
  });
  y += rowHeight;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  rows.forEach((r) => {
    if (y > pageH - 60) {
      drawFooter(doc);
      doc.addPage();
      y = 60;
    }
    x = 40;
    r.forEach((cell, i) => {
      const txt = String(cell ?? "");
      const clip = txt.length > 28 ? txt.slice(0, 26) + "…" : txt;
      doc.text(clip, x + 4, y);
      x += columnWidths[i];
    });
    doc.setDrawColor(230);
    doc.line(40, y + 4, pageW - 40, y + 4);
    y += rowHeight;
  });
  return y;
}

export function downloadReportPDF({ title, subtitle, headers, rows, columnWidths, totals }) {
  const doc = new jsPDF({ unit: "pt", format: "a4", orientation: "landscape" });
  drawHeader(doc, title);
  if (subtitle) {
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(80);
    doc.text(subtitle, 40, 118);
    doc.setTextColor(0);
  }
  let y = drawTable(doc, headers, rows, 145, columnWidths);
  if (totals && totals.length) {
    y += 10;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    totals.forEach(([label, val]) => {
      doc.text(`${label}: ${val}`, 40, y);
      y += 14;
    });
  }
  drawFooter(doc);
  doc.save(`${title.replace(/\s+/g, "_")}-${new Date().toISOString().slice(0, 10)}.pdf`);
}
